<script setup lang="ts">
import { computed } from 'vue';
import type { CharacterHistoryEntry } from '../types/relationships';

const props = defineProps<{ entries: CharacterHistoryEntry[] }>();
const emit = defineEmits<{ openEntity: [id: string] }>();
const relationships = computed(() => props.entries.filter((entry) => entry.kind === 'relationship'));
</script>

<template>
  <section class="character-tab-panel">
    <header><h2>Beziehungen</h2><p>Diese Ansicht zeigt die bereits erfassten Beziehungen. Änderungen erfolgen in der zentralen Beziehungsverwaltung.</p></header>
    <p v-if="!relationships.length" class="character-tab-empty">Noch keine Beziehungen vorhanden.</p>
    <div v-else class="character-profile-cards">
      <article v-for="entry in relationships" :key="entry.id" class="character-profile-entry">
        <button v-if="entry.counterpartId" type="button" class="character-profile-link" @click="emit('openEntity', entry.counterpartId)">{{ entry.counterpartTitle }}</button>
        <strong>{{ entry.perspectiveLabel }}</strong>
        <p v-if="entry.value">{{ entry.value }}</p>
        <small>{{ entry.startLabel }}<template v-if="entry.endLabel"> – {{ entry.endLabel }}</template><template v-if="entry.groupEntityTitle"> · {{ entry.groupEntityTitle }}</template></small>
        <p v-if="entry.notes">{{ entry.notes }}</p>
      </article>
    </div>
  </section>
</template>
